import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Toaster = () => (
  <ToastContainer
    position="top-center"
    autoClose={2000}
    hideProgressBar={false}
    closeOnClick={true}
    pauseOnHover={true}
    draggable={false}
    theme="colored"
  />
);

export default Toaster;
